import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';

import './DaySchedule.scss';

function addZero(i) {
  if (i < 10) {
    return `0${i}`;
  }
  return i;
}

function DaySchedule({seancesByDay, onSeanceClick}) {
  const [readMore, setReadMore] = useState(false);

  const {t, i18n} = useTranslation();

  return (
    <div className="DaySchedule-container">
      <div className="DS-date">
        {seancesByDay &&
          new Date(seancesByDay[0].start_time).toLocaleString(i18n.language, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          })}
      </div>
      <div className={readMore ? 'DS-options-container opened' : 'DS-options-container'}>
        {seancesByDay?.map((seance, i) => (
          <Button
            key={i}
            className="DS-options-item"
            variant="outlined"
            onClick={() => {
              onSeanceClick(seance);
            }}
          >
            {addZero(new Date(seance.start_time).getHours()) + ':' + addZero(new Date(seance.start_time).getMinutes())}
          </Button>
        ))}
      </div>
      {seancesByDay.length >= 4 && (
        <Button className="DS-more" onClick={() => setReadMore(!readMore)}>
          {readMore ? t('--de-seances') : t('+-de-seances')}
        </Button>
      )}
    </div>
  );
}

export default DaySchedule;
